//  Copyright © Veeam Software Group GmbH

import type { RestoreSessionStatus, RestoreSessionType } from 'services/restoreService';
import type { LocalizableString, Resources } from 'infrastructure/resources';
import type { EnumMap } from 'infrastructure/types';

export { restoreSessionStatusIconMap } from 'components/mappers';

export const getTypeToTitleMap = (
    resources: Resources['features']['RestoreSessions']['SessionsGrid']['types']
): EnumMap<RestoreSessionType, LocalizableString> => ({
    Vex: resources.vex,
    Vesp: resources.vesp,
    Veod: resources.veod,
    Vet: resources.vet,
});

export const getStatusToTitleMap = (
    resources: Resources['features']['RestoreSessions']['SessionsGrid']['statuses']
): EnumMap<RestoreSessionStatus, LocalizableString> => ({
    Running: resources.running,
    Success: resources.success,
    Warning: resources.warning,
    Failed: resources.failed,
    Stopping: resources.stopping,
});
